import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Breadcrumb, Pagination, message, Modal, Radio, Button } from 'antd';
import { withRouter,Link } from 'react-router-dom'

/** Personal Component **/
import $ from '$';
import Question from '@/entry_question_editor/question/question_view/view';
import SignDetail from './sign_detail';
import * as action from '../action.js';
import { typeMap, questionTypeMap } from '../constData';
import '@/css/image_correction.less'

// 参数
const RadioGroup = Radio.Group;
// task_stage - 10标记中,20标记审核中,21标记返工,22待插画(标记审核通过),30插画中,40插画审核中,41插画返工,42题目待审核,50题目审核中,60订正
class MissionDetail extends Component {
	state = {
		page: 1,
		imgGroup: [], // 原图片列表
		// tagValue: '', // 图片标记类型-1合格 2错图 3歧义 4相似 5丑图
		isShowRewordModal: false, // 是否显示返工弹窗
		isShowPicRewordModal: false,// 是否显示插画审核返工弹窗
		rewordReason: '', // 返工原因-标记审核
		picRewordReason: '', // 返工原因-插画审核中
	}
	componentWillMount() {
		const task_id =  this.props.match.params[0];
		// 任务进行到的位置
		this.props.getTaskPosition({task_id}, () => {
			const { positionDetail } = this.props;
			const { current_question, question_list, total } = positionDetail;
			let page = 1;

			question_list && question_list.length > 0 && question_list.forEach((item, index) => {
				if (item.question_id === current_question) {
					page = index + 1;
				}
			});
			this.setState({page});
			// 获取标题详情
			const params = {
				question_id: current_question,
				task_id
			}
			this.props.getTitleDetail(params, () => {
				const { titleDetail, newImgList } = this.props;
				const { imgGroup } = this.state;
				const { icon } = titleDetail;
				let imgList = [];
				let imgGroupNew = [...imgGroup];
				if (icon && icon.length > 0) {
					icon.forEach((item, index) => {
						let itemSrc = item.new ? item.new : '';
						imgGroupNew[index].src = item.old;
						imgList.push(itemSrc);
					})
				}
				this.setState({imgGroup: imgGroupNew});
				this.props.editParam({newImgList: imgList});
			});
		});
	}
	// 参数发生变化
	editParam = (obj) => {
		this.props.editParam(obj)
	}
	// 页码发生变化
	onPageChange = (page) => {
		const task_id =  this.props.match.params[0];
		const { positionDetail } = this.props;
		const { current_question, question_list, total } = positionDetail;
		let question_id = current_question;

		if (page > total) { // 大于当前页数，返回
			return;
		}
		
		question_list && question_list.length > 0 && question_list.forEach((item, index) => {
			if (index === (+page -1)) {
				question_id = item.question_id;
			}
		});

		// 获取标题详情
		const params = {
			question_id,
			task_id
		}
		const newState = Object.assign({}, positionDetail, {current_question: question_id});
		this.props.getTitleDetail(params, () => {
			const { titleDetail, newImgList } = this.props;
			const { imgGroup } = this.state;
			const { icon } = titleDetail;
			let imgList = [], imgGroupNew = [...imgGroup];

			if (icon && icon.length > 0) {
				icon.forEach((item, index) => {
					let itemSrc = item.new ? item.new : '';
					imgGroupNew[index].src = item.old || '';
					imgList.push(itemSrc);
				})
			}
			this.setState({imgGroup: imgGroupNew});
			this.props.editParam({newImgList: imgList});
		});
		this.props.editParam({positionDetail: newState});
		this.setState({page});

	}

	// 获取题目详情
	getRenderData = (obj, type) => {
		let imgGroup = [];
		let stem =  `<div>${obj.stem}</div>` || '';
		let item_list = obj.item_list || [];
		// 处理stem的图片
		let stemImgArr = $(stem).find('img');
		for (let i = 0; i < stemImgArr.length; i++) {
			if (!!stemImgArr.eq(i).attr('width')) { // 插入空格没有width属性
				let obj = {
					src: stemImgArr.eq(i).attr('src'),
					name: stemImgArr.eq(i).attr('class')
				}
				imgGroup.push(obj)
			}	
		}

		// 处理item_list（选项）图片
		item_list.length > 0 && item_list.forEach((item) => {
			let optionStem = item.item;
			let itemListImgArr = $(optionStem).find('img');
			for (let i = 0; i < itemListImgArr.length; i++) {
				let obj = {
					src: itemListImgArr.eq(i).attr('src'),
					name: itemListImgArr.eq(i).attr('class')
				}
				imgGroup.push(obj)
			}
		});

		// 处理canvans 图片
		if (type && type === 'hollow') {	
			let canvasStem = $(stem).find('canvas');
			let pStem = $(stem).find('p');
			for (let i = 0; i < canvasStem.length; i++) {
				let obj = {
					src: canvasStem.eq(i).attr('data-image'),
					name: canvasStem.eq(i).attr('class')
				}
				imgGroup.push(obj)
			}
		}

		this.setState({imgGroup});
	}

	// 改变图片类型
	handleTagChange = (val) => {
		// this.setState({tagValue: val});
		const { titleDetail } = this.props;
		const { error_type } = titleDetail;
		let newProps = Object.assign({}, titleDetail, {error_type: val});
		this.props.editParam({titleDetail: newProps});
	}

	// 保存标记（标记中）
	handleClickSave = (content) => {
		const task_id =  this.props.match.params[0];
		const { positionDetail, newImgList, titleDetail } = this.props;
		const { imgGroup, page } = this.state;
		const { current_question, total } = positionDetail;
		const { task_stage, error_type } = titleDetail;
		let newParam = {
			task_id,
			question_id: current_question,
			error_type,
			mark: content
		}

		// 保存成功回调
		const successCallback = () => {
			message.success('保存成功～');
			let newPage = page;
			if (page !== total) {
				newPage = page + 1;
			}
			// 跳转到下一页
			this.onPageChange(newPage);
			this.changePageStatus(newPage); // 改变分页的状态			
		}

		if (task_stage === typeMap.signing) { // 标记中
			// 标记图片
			// if (error_type !== '1' && !content) {
			// 	message.error('标记不能为空');
			// 	return false;
			// }
			this.props.signTitle(newParam, () => {
				successCallback();
			})
		}
		else if (task_stage === typeMap.sign_rework) { // 标记返工
			// 标记返工
			// if (error_type !== '1' && !content) {
			// 	message.error('标记不能为空');
			// 	return false;
			// }

			this.props.signModyfy(newParam, () => {
				successCallback();
			})
		}
		else if (task_stage === typeMap.icon_ing) { // 插画中
			let icon = [];
			imgGroup.length > 0 && imgGroup.forEach((item, index) => {
				let obj = {
					old: item.src,
					new: newImgList[index] || ''
				}
				icon.push(obj);
			});

			const paramNew = {
				task_id,
				question_id: current_question,
				icon
			}
			// 插画中
			this.props.insertPicture(paramNew, () => {
				successCallback();
			})
		}
		else if (task_stage === typeMap.icon_rework) { // 插画返工
			let icon = [];	
			imgGroup.length && imgGroup.forEach((item, index) => {
				let obj = {
					old: item.src,
					new: newImgList[index] || ''
				}
				icon.push(obj);
			});
			const paramNew = {
				task_id,
				question_id: current_question,
				icon
			}
			// 插画中
			this.props.modifyPicture(paramNew, () => {
				successCallback();
			})
		}
		
	}
	// 处理返工
	handleClickRework = () => {
		const { titleDetail } = this.props;
		const { task_stage } = titleDetail;
		if (task_stage === typeMap.icon_checking || task_stage === typeMap.checking) { // 插画审核中-返工
			this.setState({isShowPicRewordModal: true});
			return;
		}
		this.setState({isShowRewordModal: true});
	}

	// 标记返工原因更改
	onRadioChange = (e) => {
		let rewordReason = e.target.value;
		this.setState({rewordReason})
	}

	// 图片审核中返工原因
	onRadioPicChange = (e) => {
		let picRewordReason = e.target.value;
		this.setState({picRewordReason})
	}

	// 取消返工 - 标记审核中
	handleCancelReword = () => {
		this.setState({
			isShowRewordModal: false,
			rewordReason: ''
		})
		this._textEle.value = '';
	}
	// 取消返工 - 插花审核中
	handleCancelPicReword = () => {
		this.setState({
			isShowPicRewordModal: false,
			picRewordReason: ''
		})
		this._textPicEle.value = '';
	}

	// 确认返工 - 标记审核中
	handleOkReword = () => {
		const { positionDetail } = this.props;
		const { rewordReason, page } = this.state;
		const { current_question, total } = positionDetail;
		const rewordReason2 = this._textEle.value;
		const task_id =  this.props.match.params[0];
		const rework_mark = (rewordReason && (rewordReason.length > 0) ? (rewordReason + ',') : '') + rewordReason2;

		const param = {
			task_id,
			question_id: current_question,
			rework_mark 
		}
		// 	确认返工
		this.props.signRework(param, () => {
			message.success('返工成功～');
			this.handleCancelReword();

			let newPage = page;
			if (page !== total) {
				newPage = page + 1;
			}

			this.onPageChange(newPage);
			this.changePageStatus(newPage); // 改变分页的状态
			
		}, () => {
			message.error('返工失败～');
			this.handleCancelReword();	
		});
	}

	// 确认返工 - 插画审核中
	handleOkPicReword = () => {
		const { positionDetail } = this.props;
		const { picRewordReason, page } = this.state;
		const { current_question, total } = positionDetail;
		const rewordReason2 = this._textPicEle.value;
		const task_id =  this.props.match.params[0];
		const rework_mark = (picRewordReason && (picRewordReason.length > 0) ? (picRewordReason + ',') : '') + rewordReason2;

		const param = {
			task_id,
			question_id: current_question,
			rework_mark 
		}
		// 	确认返工
		this.props.pictureRework(param, () => {
			message.success('返工成功～');
			this.handleCancelPicReword();

			let newPage = page;
			if (page !== total) {
				newPage = page + 1;
			}
			this.onPageChange(newPage);
			this.changePageStatus(newPage); // 改变分页的状态	
			
		}, () => {
			message.error('返工失败～');
			this.handleCancelPicReword();
		});
	}

	// 处理通过
	handleClickPass = (content) => {
		const task_id =  this.props.match.params[0];
		const { positionDetail, newImgList, titleDetail } = this.props;
		const { task_stage, error_type, stage } = titleDetail;
		const { imgGroup, page } = this.state;
		const { current_question, total } = positionDetail;

		if (+stage === 11 || +stage === 21) { // 已通过不需要走接口～
			message.success('已通过～');

			if (page === total) { // 最后一页
				this.onPageChange(page);
				return false;
			}

			let newPage = page + 1;
			// 跳转到下一页
			this.onPageChange(newPage);
			return false;
		}

		if (task_stage === typeMap.sign_checking) { // 标记审核
			let newParam = {
				task_id,
				question_id: current_question,
				error_type,
				mark: content
			}

			// 标记通过
			this.props.signPass(newParam, () => {
				message.success('通过成功～');

				let newPage = page;
				if (page !== total) {
					newPage = page + 1;
				}
				this.onPageChange(newPage);
				this.changePageStatus(newPage); // 改变分页的状态
				
			})
		}
		else if (task_stage === typeMap.icon_checking || task_stage === typeMap.checking) { // 插画审核
			let icon = [];
			imgGroup.length && imgGroup.forEach((item, index) => {
				let obj = {
					old: item.src,
					new: newImgList[index] || ''
				}
				icon.push(obj);
			});
			const paramNew = {
				task_id,
				question_id: current_question,
				icon
			}
			// 审核通过
			this.props.picturePass(paramNew, () => {
				message.success('通过成功～');
				let newPage = page;
				// 题目审核不需要跳转下一页，直接获取新的详情
				// 最后一个不需要跳转下一页
				if (task_stage !== typeMap.checking && page !== total) {
					newPage = page + 1;
				}
				this.onPageChange(newPage);
				this.changePageStatus(newPage); // 改变分页的状态
				
			})
		}
		
	}

	// 下一题
	handleNextBtn = () => {
		const { positionDetail } = this.props;
		const { total } = positionDetail;
		const { page } = this.state;

		if (page === total) {
			message.error('已经是最后一题了～');
			return false;
		}
		// 跳转到下一页
		let newPage = page + 1;
		this.onPageChange(newPage);
	}

	// 修改渲染内容-分页
	itemRender = (page, type, originalElement) => {
		const { titleDetail, positionDetail } = this.props;
		const { task_stage } = titleDetail;
		const { question_list } = positionDetail;
		
		if (type === 'page') {
			let stage = question_list[page-1].stage;
			// 标记中(task_stage=10&stage=10)
			// 标记审核中(task_stage=20&stage=11(通过)task_stage=20&stage=12(返工))
			// 标记返工(task_stage=21&stage=13)
			// 插画中(task_stage=30&stage=20)
			// 插画审核中(task_stage=40&stage=21(通过)；task_stage=40&stage=22(返工))
			// 插画返工(task_stage=41&stage=23)
			// 题目审核中(task_stage=50&stage=21(通过)；task_stage=50&stage=22(返工))

			let operatePass = (task_stage === typeMap.signing && stage=== questionTypeMap.signing) || 
							  (task_stage === typeMap.sign_checking && stage=== questionTypeMap.sign_pass) ||
							  (task_stage === typeMap.sign_rework && stage=== questionTypeMap.sign_modify) ||
							  (task_stage === typeMap.icon_ing && stage=== questionTypeMap.iconed) ||
							  (task_stage === typeMap.icon_checking && stage=== questionTypeMap.icon_pass) ||
							  (task_stage === typeMap.icon_rework && stage=== questionTypeMap.icon_modify) ||
							  (task_stage === typeMap.checking && stage=== questionTypeMap.icon_pass);
			let operateRework = (task_stage === typeMap.sign_checking && stage=== questionTypeMap.sign_rework) ||
								(task_stage === typeMap.icon_checking && stage=== questionTypeMap.icon_rework) ||
								(task_stage === typeMap.checking && stage=== questionTypeMap.icon_rework);
			let newClassName = operatePass ? 'green-page' : (operateRework ? 'blue-page' : '');

			return (
				<Button className={newClassName}>{page}</Button>
			) 
		}
		else {
			return originalElement;
		}
	}

	// 更新分页的状态
	changePageStatus = (page) => {
		const task_id =  this.props.match.params[0];
		let { positionDetail } = this.props;
		let { current_question, question_list } = positionDetail;
		question_list && question_list.length > 0 && question_list.forEach((item, index) => {
			if (index === (+page -1)) {
				current_question = item.question_id;
			}
		});
		// 任务进行到的位置
		this.props.getTaskPosition({task_id}, () => {
			let { positionDetail } = this.props;
			const newState = Object.assign({}, positionDetail, {current_question});
			this.props.editParam({positionDetail: newState});
		});
	}

	// mark 改变
	handleMarkChange = (value) => {
		const { titleDetail } = this.props;
		const { mark } = titleDetail;
		let newProps = Object.assign({}, titleDetail, {mark: value});
		this.props.editParam({titleDetail: newProps});
	}

	render() {

		const { positionDetail, titleDetail, type, newImgList, button } = this.props;
		const { imgGroup, rewordReason, picRewordReason } = this.state;
		const { task_stage, error_type, mark, rework_mark, stage } = titleDetail;
		const { total } = positionDetail;
		const rightDetail = {
			error_type,
			mark,
			rework_mark
		}

		return(
			<div>
				<Row>
					<Col span={8}>
						<Breadcrumb className="breadCrumb">
		                    <Breadcrumb.Item className="breadItem">
		                        <span>题目管理</span>
		                    </Breadcrumb.Item>
		                    <Breadcrumb.Item className="breadItem">
		                        <Link to="/questionmanage/imageCorrection">图片订正</Link>
		                    </Breadcrumb.Item>
		                    <Breadcrumb.Item className="breadItem">
		                        <span>任务详情</span>
		                    </Breadcrumb.Item>
                		</Breadcrumb>
					</Col>
					{
	                    total && +total > 0 &&
	                    <Col span={16}>
	                        <Pagination 
	                        	current={this.state.page}
	                            total={total}
	                            className="pagination-reset"
	                            onChange={this.onPageChange}
	                            pageSize={1}
	                            itemRender={this.itemRender}
	                        />
	                    </Col>
	                }
				</Row>
                <Row gutter={40} style={{marginTop: '25px'}}>
                	<Col span={15}>
	                	{
	                		titleDetail && titleDetail.question_id ? 
	                			<Question data={titleDetail} num={this.state.page-1} getData={this.getRenderData} /> :
	                			<div style={{fontSize: "16px", height: "30px", paddingBottom: "50px", minHeight: '200px', border: '1px solid #eee'}}>
	                                <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
	                            </div>

	                	}
                	</Col>
                	{/*right content*/}
                	<SignDetail 
                		data={imgGroup} // 原图片列表
                		// tagValue={error_type} // 图片标记类型
                		buttonPower={button} // 按钮权限
                		type={task_stage} // 任务类型
                		newImgList={newImgList} // 新的图片列表
                		rightDetail={rightDetail} // 右侧详细信息
                		onTagChange={this.handleTagChange} // 改变图片类型
                		onClickSave={this.handleClickSave} // 保存标记(标记中)
                		onClickReword={this.handleClickRework} // 处理返工（标记审核）
                		onClickPass={this.handleClickPass} // 处理通过（标记审核）
                		onClickNextBtn={this.handleNextBtn} // 下一页
                		onMarkChange={this.handleMarkChange} // 处理标记改变
                		editParam={this.editParam} // 编辑参数
                	/>
                </Row>
                <Modal
					title="标记返工原因填写"
					visible={this.state.isShowRewordModal}
					cancelText="取消"
					okText="确认"
					onOk={this.handleOkReword}
					onCancel={this.handleCancelReword}>
					<div className="rework-reason">
						<RadioGroup 
							onChange={this.onRadioChange}
							value={rewordReason}
							className="signRadio">
							<Radio value="标记分类错误">标记分类错误</Radio>
							<Radio value="修改建议不够详细">修改建议不够详细</Radio>
							<Radio value="修改意见错误">修改意见错误</Radio>
						</RadioGroup>
						<textarea
							rows={4} 
							name="text"
							style={{marginTop: '10px'}}
							className="modify-explain"
							ref={ele => this._textEle = ele}
						></textarea>
					</div>
				</Modal>
				<Modal
					title="返工原因填写"
					visible={this.state.isShowPicRewordModal}
					cancelText="取消"
					okText="确认"
					onOk={this.handleOkPicReword}
					onCancel={this.handleCancelPicReword}>
					<div className="rework-reason">
						<RadioGroup 
							onChange={this.onRadioPicChange}
							value={picRewordReason}
							className="signRadio">
							<Radio value="图片有误">图片有误</Radio>
							<Radio value="图片不符合修改建议">图片不符合修改建议</Radio>
						</RadioGroup>
						<textarea
							rows={4} 
							name="text"
							style={{marginTop: '10px'}}
							className="modify-explain"
							ref={ele => this._textPicEle = ele}
						></textarea>
					</div>
				</Modal>
            </div>

		);
	}

}

const mapStateTopProps = (state) => {
	let imageCorrection = state.questionManage.imageCorrection;
	let userInfo = state.user;
	let button = userInfo.role_icon ? userInfo.role_icon.buttons : {};
	return {
		positionDetail: imageCorrection.positionDetail,
		titleDetail: imageCorrection.titleDetail,
		newImgList: imageCorrection.newImgList,
		button
	};
}
const mapDispatchToProps = dispatch => {
	return {
		editParam: (params) => { 
            dispatch(action.editParam(params));
        },
		// 任务进行到的位置
		getTaskPosition: (param, callback) => {
			dispatch(action.getTaskPosition(param, callback))
		},
		// 题目详情
		getTitleDetail: (param, callback) => {
			dispatch(action.getTitleDetail(param, callback))
		},
		// 标记图片
		signTitle: (param, callback) => {
			dispatch(action.signTitle(param, callback))
		},
		// 标记返工
		signRework: (param, callback, err) => {
			dispatch(action.signRework(param, callback, err))
		},
		// 标记通过
		signPass: (param, callback) => {
			dispatch(action.signPass(param, callback))
		},
		// 标记修改
		signModyfy: (param, callback) => {
			dispatch(action.signModyfy(param, callback))
		},
		// 插画中
		insertPicture: (param, callback) => {
			dispatch(action.insertPicture(param, callback))
		},
		// 插画审核通过
		picturePass: (param, callback) => {
			dispatch(action.picturePass(param, callback))
		},
		// 插画审核返工
		pictureRework: (param, callback, err) => {
			dispatch(action.pictureRework(param, callback, err))
		},
		// 修改插画
		modifyPicture: (param, callback, err) => {
			dispatch(action.modifyPicture(param, callback, err))
		},
	}
};
export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(MissionDetail))


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/view.js